import { c as _c } from "react/compiler-runtime";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WaveDropActions from "@/components/waves/drops/WaveDropActions";
interface MemeDropActionsProps {
  readonly drop: ExtendedDrop;
  readonly isMobile: boolean;
  readonly showReplyAndQuote: boolean;
  readonly onReply: () => void;
  readonly onQuote: () => void;
}
export default function MemeDropActions(t0) {
  const $ = _c(4);
  const {
    drop,
    isMobile,
    showReplyAndQuote,
    onReply,
    onQuote
  } = t0;
  if (isMobile || !showReplyAndQuote) {
    return null;
  }
  let t1;
  if ($[0] !== drop || $[1] !== onQuote || $[2] !== onReply) {
    t1 = <WaveDropActions drop={drop} activePartIndex={0} onReply={onReply} onQuote={onQuote} />;
    $[0] = drop;
    $[1] = onQuote;
    $[2] = onReply;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}